const SYS_PROMPT = `You are a precise technical editor.
Return JSON ONLY:
{
  "tldr": "<= 25 words>",
  "key_takeaways": ["3-5 concise bullets"],
  "audience": "short",
  "prereqs": "short",
  "read_minutes": 0
}`;

function chunkText(s, maxChars = 1000) {
  if (!s || s.length <= maxChars) return [s || ""];
  const out = [];
  let i = 0;
  while (i < s.length) {
    const j = Math.min(s.length, i + maxChars);
    const k = s.lastIndexOf("\n\n", j);
    const end = k > i + 800 ? k : j;
    out.push(s.slice(i, end));
    i = end;
  }
  return out;
}

async function runJSON(engine, userContent) {
  const out = await engine.chat.completions.create({
    messages: [
      { role: "system", content: SYS_PROMPT },
      { role: "user", content: userContent },
    ],
    temperature: 0.2,
    max_tokens: 512,
  });

  const text = out?.choices?.[0]?.message?.content ?? "";
  console.log("[WebLLM raw model output]", text);  const first = text.indexOf("{");
  const last = text.lastIndexOf("}");
  const jsonStr = first >= 0 && last > first ? text.slice(first, last + 1) : "{}";
  return JSON.parse(jsonStr);
}

// Called by pages/components through the Provider
export async function summarizeWithEngine(engine, rawText) {
  const chunks = chunkText(rawText || "");
  const partials = [];
  console.log("Summarizing content")
  for (const c of chunks) {
    const p = await runJSON(engine, `Summarize this article segment as required JSON.\n\n---\n${c}\n---`);
    partials.push(p);
  }

  const merged = {
    tldr: partials[0]?.tldr || "Summary",
    key_takeaways: [],
    audience: partials[0]?.audience || "General readers",
    prereqs: partials[0]?.prereqs || "None",
    read_minutes: Math.max(1, Math.min(60, Math.ceil((rawText || "").split(/\s+/).length / 220))),
  };

  const seen = new Set();
  for (const p of partials) {
    (p?.key_takeaways || []).forEach(k => {
      const s = String(k || "").trim();
      if (s && !seen.has(s)) {
        seen.add(s);
        merged.key_takeaways.push(s);
      }
    });
  }
  merged.key_takeaways = merged.key_takeaways.slice(0, 6);
  if (merged.tldr.length > 220) merged.tldr = merged.tldr.slice(0, 220);
  console.log(merged);
  return merged;
}
